import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { Alert } from 'app/models/dto/alert.model';
import { Contact, NewContact } from 'app/models/dto/contact.model';
import { LenderUser } from 'app/models/dto/lender-user.model';
import { NonOwnerPersonnel } from 'app/models/dto/non-owner-personnel.model';
import { EventBusService } from 'app/modules/shared/services/event-bus.service';
import { DismissContactAlert } from 'app/store/contact/contact.actions';
import { ContactState } from 'app/store/contact/contact.state';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { DismissNonOwnerPersonnelAlert, SetNewNonOwnerPersonnel } from 'app/store/non-owner-personnel/non-owner-personnel.actions';
import { NonOwnerPersonnelState } from 'app/store/non-owner-personnel/non-owner-personnel.state';
import { combineLatest, map, Observable } from 'rxjs';

@Component({
  selector: 'app-edit-contact-dialog',
  templateUrl: './edit-contact-dialog.component.html',
  styleUrls: ['./edit-contact-dialog.component.scss', '../../../form-core/formly/formly-grid-styles.scss']
})

export class EditContactDialogComponent implements OnInit {

  @Select(ContactState.contacts) existingContacts$: Observable<Contact[]>;
  @Select(ContactState.newContact) newContact$: Observable<NewContact>;
  @Select(ContactState.alerts) alerts$: Observable<Alert[]>;
  @Select(NonOwnerPersonnelState.nonOwnerPersonnel) nonOwnerPersonnel$: Observable<NonOwnerPersonnel[]>;
  @Select(NonOwnerPersonnelState.newNonOwnerPersonnel) newNonOwnerPersonnel$: Observable<NonOwnerPersonnel>;
  @Select(NonOwnerPersonnelState.alerts) nopAlerts$: Observable<Alert[]>;
  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;

  allAlerts$: Observable<Alert[]>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      borrowerId: number;
      emailAddress: string;
    },
    private store: Store,
    private renderer: Renderer2,
    private eventBusService: EventBusService,
    private dialogRef: MatDialogRef<EditContactDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.allAlerts$ = combineLatest([this.alerts$, this.nopAlerts$]).pipe(
      map(
        ([contactAlerts, nonOwnerPersonnelAlerts]) => contactAlerts.concat(nonOwnerPersonnelAlerts)
      )
    );
  }

  close() {
    this.eventBusService.publish(new this.eventBusService.types.ContactDialogClosedEvent);
    this.dialogRef.close();
  }

  dismissAlert(alert: Alert) {
    this.store.dispatch(new DismissContactAlert(alert));
    this.store.dispatch(new DismissNonOwnerPersonnelAlert(alert));
  }

  addPersonnel() {
    this.store.dispatch(new SetNewNonOwnerPersonnel());
    this.scrollToTop();
  }

  scrollToTop() {
    this.renderer.selectRootElement('#topDialog').scrollIntoView({ behavior: 'smooth' });
  }

}
